import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ResponsiveNav from '../components/navigation/navigation';
import { Box, CircularProgress, Typography} from '@mui/material';
import CourseItem from '../components/CourseItem/courseitem';


import { courses } from '../data/StaticDatas';
import CourseReviewsAndRating from '../components/CourseReviewsAndRating/CourseReviewsAndRating';
import { useGet } from '../hooks/useApi';
const CourseDetails = () => {
  const { id } = useParams();  

  const { data: itemDetails, error: itemErr, isLoading: itemLoader} = useGet(`/api/Courses/${id}`);
  const item = itemDetails?.data.details
  console.log(itemDetails?.data);
  const courseOverviewDetails = itemDetails?.data.whyChooseCourse
  
  
  // const {longDesciption,name,size,} = item
  console.log(item);

  const breadcrumbItems = [
    { label: 'Home', link: '/' },
    { label: 'Digital Courses', link: '/product/digital-courses' },
    { label: `Product Details`, link: `/product/digital-courses/${id}` },
  ];

  const [loading, setLoading] = useState(false);
  useEffect(() => {


    if (itemLoader) {
      setLoading(true);
      return;
    }

  }, [itemLoader]);


  //  // Find the gift by its ID
  //  const gift = item?.find(gift => gift.id === id);
  //  console.log(gift.specification.map((item)=>({label:item.Label, value:item.Value})))

   // If the gift doesn't exist, show an error
   if (itemLoader) {
    return <CircularProgress sx={{ display: "block", margin: "20px auto" }} />;
  }

  if (itemErr) {
    return (
      <Typography color="error" sx={{ textAlign: 'center', mt: 4, fontFamily: theme => theme.typography.smallText }}>
        There was an error loading this course. Our technical support team will fix it ASAP.
      </Typography>
    );
  }
  

// console.log(item?.map((item) => [{ label: 'Duration', value: `${item.duration}` },  { label: 'Format', value: item.format },
//   { label: 'Certification', value: item.certification }]));




  // // Find the course by its ID
  // const course = courses.find(course => course.id === id);


  // // If the course doesn't exist, show an error
  // if (!course) {
  //   return <div>Course not found!</div>;
  // }

  return (
    <Box>
         <ResponsiveNav breadcrumbItems={breadcrumbItems} searchValue="" onSearchChange={() => {}} searchPlaceholder="Search..." />
         <CourseItem
  buttontext="Save For Later"
  detail="Course Details"
  items={item}
  category_title={item?.categoryName || 'No Category'}
  item_details={[
    { label: 'Duration', value: item?.duration || 'Not specified' },
    { label: 'Format', value: item?.format || 'Not specified' },
    { label: 'Certification', value: item?.certification || 'Not available' }
  ]}
/>

       {/* <CourseItem buttontext={'Save For Later'} detail='Course Details' items={item} category={item.categoryName} item_details={item?.map((item) => [{ label: 'Duration', value: `${item.duration}` },  { label: 'Format', value: item.format },
    { label: 'Certification', value: item.certification }])}/> */}
      <Box sx={{mt:8}}>
        <CourseReviewsAndRating courseItems={item} courseOverviewDetails={courseOverviewDetails}/>
      </Box>
    </Box>
  );
};

export default CourseDetails;
